<template>
  <div>
    <div class="backgroundGrey">
      <b-container class="newslist">
        <b-row>
          <b-col lg="6" sm="12">
            <h2 class="heading">Clutch Tour 
              <template v-if="tournID == 'cpt'">Tier 1</template>
              <template v-else-if="tournID == 'cp2'">Tier 2</template>
              <template v-else-if="tournID == 'cp3'">Amateur</template>
              <template v-else-if="tournID == 'pam'">Pro-Ams</template>
              <template v-else-if="tournID == 'qsc'">Q-School</template>
              
            
            News </h2>
          </b-col>
          <b-col lg="6" sm="12">
            <b-dropdown id="dropdown-1" :text="title" class="m-md-2">
              <b-dropdown-item value="all" title="All News" v-on:click="pickNews">All News</b-dropdown-item>
              <b-dropdown-item value="cpt" title="Tier 1 News" v-on:click="pickNews">Tier 1 News </b-dropdown-item>
              <b-dropdown-item value="cp2" title="Tier 2 News" v-on:click="pickNews">Tier 2 News </b-dropdown-item>
              <b-dropdown-item value="cp3" title="Amateur League News" v-on:click="pickNews">Amateur League News</b-dropdown-item>
              <b-dropdown-item value="pam" title="Pro-Ams News" v-on:click="pickNews">Pro-Ams News</b-dropdown-item>
              <b-dropdown-item value="qsc" title="Q-School" v-on:click="pickNews">Q-School News</b-dropdown-item>
            </b-dropdown>
          </b-col>
        </b-row>
        <div v-if="loading == true">
          <div class="loader"></div>
          <h2 class="loading">Loading...</h2>
        </div>
        <b-row v-else>
          <b-col
            lg="4"
            id="mobilePost"
            v-for="(posts, index) in SecondDatetime"
            :key="'thirtyninedex' +index"
            class="colsMargin"
          >
            <b-nav-item :to="'/news/' + posts.slug">
              <div class="overflowImage postsource" v-bind:style="{ 'background-image': 'url(' + posts.better_featured_image.source_url + ')' }">
              </div>
              <div class="FirstPostContentBlock">
                <p class="date">{{posts.PostnewDate}}</p>
                <h1 class="postsTitle LeftImage">
                  <span v-html="posts.title.rendered"></span>
                </h1>
              </div>
              <div class=""></div>
            </b-nav-item>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
  
</template>

<script>
import apiCall from "@/services/api.js";
export default {
  name: "posts",
  props: ["config"],
  data() {
    return {
      posts: [],
      showAllnews: '',
      title: 'All News',
      loading: true
    };
  },
  computed: {
    SecondDatetime: function() {
      let Allpost = this.posts
      console.log("Allpost")
      console.log(Allpost)
      // let arr = [];

      this.posts.forEach((value) => {
          var dateOG = value.date.split('T')
          var splitDate = dateOG[0].split('-')
          var newDate = splitDate[2]+ '/' + splitDate[1] + '/' + splitDate[0]        
          value.PostnewDate = newDate;
      });
      return Allpost
    },
    dateTime:function(){
      let arr = [];
      console.log("arr")
      console.log(arr)
      this.posts.forEach((value) => {
        var dateOG = value.date.split('T')
        var splitDate = dateOG[0].split('-')
        var newDate = splitDate[2]+ '/' + splitDate[1] + '/' + splitDate[0]
        this.posts.push(newDate);
      });
      return arr
    }
  },
  methods: {
    showMoreNews: function() {
      this.showAllnews = true;
    },
    showLessNews: function() {
      this.showAllnews = false;
    },
    pickNews: function(event) {
      this.loading = true;
      var newsTitle = event.target.getAttribute("title");
      this.title = newsTitle;
      var tour = event.target.getAttribute("value");
      console.log('tour ' + tour)
      this.tournID = tour;
      console.log('this.statTour ' + this.statTour)
      this.NewsApi(tour)
    },
    // newsCat: function(tour) {
    //   if (tour == 'cpt') {
    //     this.catNews = 'color: #00FFFE'
    //   } else if (tour == 'cp2') {
    //     this.catNews = 'color: #bde9d8'
    //   } else if (tour == 'cp3') {
    //     this.catNews = 'color: #dfc3c2'
    //   } else if (tour == 'pam') {
    //     this.catNews = 'color: #fff'
    //   } else if (tour == 'qsc') {
    //     this.catNews = 'color: #bde9d8'
    //   }
    //   this.NewsApi()
    // },
    NewsApi: function (tour){
      var json = ''
      if (tour == 'cpt') {
        json = "wp/v2/posts?categories=4&per_page=100"; 
      } else if (tour == 'cp2') {
        json = "wp/v2/posts?categories=5&per_page=100";
      } else if (tour == 'cp3') {
        json = "wp/v2/posts?categories=6&per_page=100";
      } else if (tour == 'pam') {
        json = "wp/v2/posts?categories=7&per_page=100";
      } else if (tour == 'qsc') {
        json = "wp/v2/posts?categories=8&per_page=100";
      } else {
        json = "wp/v2/posts?per_page=100";
      }
      apiCall
        .wpInfo(json)
        .then(({ data }) => {
          this.posts = data;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          throw error;
        });
    }
  },
  created() {
    this.NewsApi();
  },
};
</script>

<style scoped>
h2.loading {
  padding-top: 20px;
  font-weight: 600;
  font-size: 24px;
  color: #081C3F;
  text-align: center;
  /* padding-bottom: 90px; */
}
.loader {
  border: 16px solid #f3f3f3; /* Light grey */
  border-top: 16px solid #081C3F; /* Blue */
  border-radius: 50%;
  width: 120px;
  height: 120px;
  animation: spin 2s linear infinite;
  margin: auto;
  display: block;
}
.loaderSection {
  padding-top: 30px;
  padding-bottom: 30px;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
::v-deep button#dropdown-1__BV_toggle_ {
  color: #081C3F;
  background-color: transparent;
  border-color: #081C3F;
  width: 424px;
  height: 52px;
  border-radius: 26px;
}
::v-deep .dropdown-toggle::after {
  float: right;
  position: relative;
  top: 10px;
}
::v-deep .btn {
  text-align: left;
  font-size: 18px;
  font-weight: bold;
}
::v-deep .btn-secondary {
  color: #081C3F;
  background-color: transparent;
  border-color: #081C3F;
  border-radius: 0px;
}
::v-deep .btn-secondary:hover {
  color: #081C3F;
  background-color: transparent;
  border-color: #081C3F;
}
::v-deep .btn-secondary:active {
  color: #081C3F;
  background-color: transparent;
  border-color: #081C3F;
}
::v-deep .btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active, .show > .btn-secondary.dropdown-toggle {
  color: #081C3F;
  background-color: transparent;
  border-color: #081C3F;
  width: 100%;
}
::v-deep .dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 10rem;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  font-size: 18px;
  color: #212529;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
}
div#dropdown-1 {
  width: 424px;
  height: 52px;
  text-align: left;
  float: right;
  border-radius: 0px;
}
li.nav-item:hover {
  transform: translateY(-10px);
}
li.nav-item:hover > a > .FirstPostContentBlock{
  background-color: #081C3F;
  border: 0px solid;
}
li.nav-item:hover > a > .FirstPostContentBlock > p{
  color: #00FFFE;
}
li.nav-item:hover > a > .FirstPostContentBlock > h1.postsTitle{
  color: #fff;
}
li.nav-item {
  border-radius: 6px;
    transition: all 0.4s ease;
  /* webkit-transition: all 350ms cubic-bezier(.37, 0, .63, 1); */
  transition: all 350ms cubic-bezier(.37, 0, .63, 1);
}
.rightHomePosts:hover {
  transform: translateY(-10px);
}
a.allNewsLink {
  text-decoration: none;
}
.overflowImage.postsource {
  background-repeat: no-repeat;
  height: 500px;
  background-size: cover;
  background-position: bottom;
}
.SeeMorebtn {
  margin: auto;
  text-align: center;
  display: block;
  padding-top: 50px;
  padding-bottom: 50px;
}
a.allNewsLink.router-link-exact-active.router-link-active {
  position: relative;
  top: -11px;
  text-decoration: none;
}
.outerNews {
  position: absolute; 
  left: 0;
  right: 0;
  bottom: 70px;
}
.colsMargin.col-lg-6 {
  padding-right: 0px;
  padding-left: 0px;
}
.overflowImageSecond.imageRight {
  height: 200px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
div#mobilePost {
  padding-bottom: 40px;
  transition: all 0.4s ease;
  /* webkit-transition: all 350ms cubic-bezier(.37, 0, .63, 1); */
  transition: all 350ms cubic-bezier(.37, 0, .63, 1);
}
div#mobilePost:hover {
  transform: translateY(-10px);
  transition: all 350ms cubic-bezier(.37, 0, .63, 1);
}
li.nav-item.bottomLinks > a {
  padding-left: 0px;
  padding-right: 0px;
}
.whiteBK {
  /* padding-top: 30px; */
  padding-top: 100px;
}
.backgroundGrey {
  background-color: #F8F8F8;
  padding-bottom: 50px;
  padding-top: 60px;
}
.AllbuttonsSeeAll {
  width: 244px;
  height: 50px;
  background: transparent;
  color: #081C3F;
  /* font-weight: 500; */
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
  font-style: normal;
  border-radius: 50px;
  border: 1px solid #E8E8E8;
  transition: all 0.4s ease;
  /* webkit-transition: all 350ms cubic-bezier(.37, 0, .63, 1); */
  transition: all 350ms cubic-bezier(.37, 0, .63, 1);
  border-radius: 26px;
}
.AllbuttonsSeeAll:hover {
  width: 244px;
  height: 50px;
  background: #081C3F;
  color: #fff;
  /* font-weight: 500; */
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
  font-style: normal;
  border-radius: 50px;
  border: 1px solid #E8E8E8;
  transform: translateY(-10px);
  border-radius: 26px;
}
.Allbuttons {
  /* float: right; */
  width: 244px;
  height: 50px;
  background: transparent;
  color: #081C3F;
  /* font-weight: 500; */
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
  font-style: normal;
  border-radius: 50px;
  border: 1px solid #E8E8E8;
  transition: all 0.4s ease;
  /* webkit-transition: all 350ms cubic-bezier(.37, 0, .63, 1); */
  transition: all 350ms cubic-bezier(.37, 0, .63, 1);
  margin: auto;
  display: block;
  border-radius: 26px;
}
.Allbuttons:hover {
  /* float: right; */
  width: 244px;
  height: 50px;
  background: #081C3F;
  color: #fff;
  /* font-weight: 500; */
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
  font-style: normal;
  border-radius: 50px;
  border: 1px solid #E8E8E8;
  transform: translateY(-10px);
  margin: auto;
  display: block;
  border-radius: 26px;
}
.heading{
  /* font-weight: 600; */
  font-size: 36px;
  color: #081C3F;
  padding-bottom: 50px;
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
  font-style: normal;
}
.FirstPostContentBlock {
  border: 1px solid #E8E8E8;
  width: 100%;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  padding: 35px;
  height: 240px;
  background: #fff;
}
p.date {
  color: #081c3f;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 0;
}
h1.postsTitle.LeftImage {
  /* font-weight: 600; */
  /* font-weight: 500; */
}
h1.postsTitle.rightTitles {
  font-size: 26px;
  padding-top: 40px;
}
h1.postsTitle.rightTitles > span {
  font-size: 26px;
}
img.imageRight.img-fluid.postImg {
  border-radius: 50px;
  max-width: 100%;
  height: 188px;
  width: auto;
  float: right;
}
.img-fluid {
  max-width: 100%;
  height: auto;
  width: 100%;
}
span.postText {
  font-size: 12pt;
}
h1.postsTitle {
  font-size: 24px;
  padding-top: 15px;
  padding-bottom: 15px;
  color: #081C3F;
  /* font-weight: 600; */
}
.overflowImage {
  overflow: hidden;
  /* max-height: 389px; */
  max-height: 300px;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}
.overflowImageSecond {
  overflow: hidden;
  /* height: 278px; */
  border-radius: 6px;
  max-height: 425px;
}
#mobilePost:last-child {
  /* padding-right: 0px; */
}

.postRow {
  padding-bottom: 10px;
}
::v-deep .nav-link {
  color: black !important;
  width: 100%;
  text-align: left;
  padding: 0;
}
.moreNews>a{
  background-color: transparent;
  color: #081C3F!important;
}
#leftMore{
  color: #fff;
  background-color: #081C3F;
  border-radius: 10px;
  width: 20px;
  height: 20px;
  padding: 3px;
}
@media only screen and (max-width: 1201px) {
  .FirstPostContentBlock {
    border: 1px solid #E8E8E8;
    width: 100%;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    padding: 35px;
    height: 400px;
    background: #fff;
  }
}
@media only screen and (max-width: 990px) {
  div#dropdown-1 {
    width: 424px;
    height: 52px;
    text-align: left;
    float: right;
    border-radius: 0px;
    margin-top: 30px;
  }
  h1.postsTitle.rightTitles {
    font-size: 26px;
    padding-top: 15px!important;
  }
  .FirstPostContentBlock {
    height: auto;
  }
  .whiteBK {
    padding-top: 30px;
  }
  .Allbuttons {
    float: none;
    width: 244px;
    height: 50px;
    background: transparent;
    color: #081C3F;
    /* font-weight: 500; */
    font-family: "brown-pro-condensed", sans-serif;
    font-weight: 800;
    font-style: normal;
    border-radius: 50px;
    border: 1px solid #E8E8E8;
    margin: auto;
    margin-top: 30px;
    text-align: center;
    display: block;
    transition: all 0.4s ease;
    /* webkit-transition: all 350ms cubic-bezier(.37, 0, .63, 1); */
    transition: all 350ms cubic-bezier(.37, 0, .63, 1);
    border-radius: 26px;
  }
  .Allbuttons:hover {
    float: none;
    width: 244px;
    height: 50px;
    background: #081C3F;
    color: #fff;
    /* font-weight: 500; */
    font-family: "brown-pro-condensed", sans-serif;
    font-weight: 800;
    font-style: normal;
    border-radius: 50px;
    border: 1px solid #E8E8E8;
    display: block;
    transform: translateY(-10px);
    border-radius: 26px;
  }
  .heading{
    /* font-weight: 600; */
    font-size: 36px;
    color: #081C3F;
    text-align: left;
    font-family: "brown-pro-condensed", sans-serif;
    font-weight: 800;
    font-style: normal;
  }
  ::v-deep button#dropdown-1__BV_toggle_ {
    width: 100%;
  }
  div#dropdown-1 {
    float: none;
    width: 100%;
    margin: auto;
    display: block;
    text-align: center;
  }
}
@media only screen and (max-width: 480px) {
  ::v-deep .nav-link {
    width: 100%;
  }
  #mobilePost {
    padding-top: 2%;
    padding-bottom: 2%;
  }
}
@media only screen and (max-width: 1165px) {
  #mobilePost:last-child {
    padding-right: 15px;
    margin-top: 2em;
  }
  div#mobilePost {
    margin-top: 1em;
  }
}
</style>
